export default function () {
    return {
        monitor_buffer: [],
        monitor_date: Date.now()
    };
}
